import react from 'react';

//width enum

export const inputWIdth = {
	W25: 'w-25',
  W50: 'w-50',
  W75: 'w-75',
  W100: 'w-100'
}

export class Input extends react.Component {
  constructor(props) {
    super(props);
    this.state = { 
      label: props.label, 
      htmlFor: props.htmlFor, 
      props: props.placeholder, 
      value: props.value, 
      error: props.error, 
      onChange: props.onChange,
      min: props.min,
      max: props.max,
      unit: props.unit,
      width: props.width
    };
  }

  componentWillUnmount () {
    this.state.onChange = undefined;
  }

  componentWillReceiveProps(props) {
    this.setState(
      { 
        label: props.label, 
        htmlFor: props.htmlFor, 
        props: props.placeholder, 
        value: props.value, 
        error: props.error, 
        onChange: props.onChange,
        min: props.min,
        max: props.max,
        unit: props.unit
      });  
  }

  render() {

    let inputClassName = "form-control" + (this.state.error ? " input-validation-error" : "");
    let showValidationFeedback =  this.state.error? " input-validation-error": "";
    let width = this.state.width ? this.state.width : inputWIdth.W50;
    return  <div className="form-group">
    <label htmlFor={this.state.htmlFor}>{this.state.label}</label>
    <div className={`input-group ${width}`}>
      <input type="number" 
        id={this.state.htmlFor} 
        className={inputClassName}
        placeholder={this.state.placeholder} 
        value={this.state.value} 
        onChange={this.state.onChange}
        min = {this.state.min}
        max = {this.state.max}
      />
      <label htmlFor={this.state.htmlFor} className="text-fade-color font-weight-light"> [{this.state.unit}]</label>
    </div>
      <span className={`invalid-feedback ${showValidationFeedback}`}>{this.state.error}</span>
  </div>
  }
}